import { Paper, Text } from '@mantine/core';
import { IconArrowRight } from '@tabler/icons-react';
import * as React from 'react';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import { VersionStateChangeResult } from '../../../../resource/resource-base/adapters/useVersionActions';
import { MutationValidationResultComponent } from './MutationValidationResultComponent';

export const VersionStateChangeValidationResultComponent = ({
    resourceValidation,
    resourceType,
}: {
    resourceValidation: VersionStateChangeResult;
    resourceType: ResourceType;
}) => {
    const stateChangeElement = (
        <Paper withBorder style={{ display: 'inline-flex', flexDirection: 'row', alignItems: 'center', padding: 4 }}>
            <Text style={{ minWidth: 'fit-content', marginRight: 40 }}>Attempted State Change :</Text>
            <Text
                style={{
                    textAlign: 'center',
                    minWidth: 'fit-content',
                    paddingLeft: 6,
                    paddingRight: 6,
                }}
            >
                {resourceValidation.fromState}
            </Text>
            <IconArrowRight style={{ marginLeft: 20, marginRight: 20 }} />
            <Text
                style={{
                    textAlign: 'center',
                    minWidth: 'fit-content',
                    paddingLeft: 6,
                    paddingRight: 6,
                }}
            >
                {resourceValidation.toState}
            </Text>
        </Paper>
    );

    return resourceValidation.content ?
            <MutationValidationResultComponent
                resourceValidation={resourceValidation.content}
                resourceType={resourceType}
                beforeContent={stateChangeElement}
            />
        :   stateChangeElement;
};
